import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { HttpCssClient } from './http-request.interceptor';
import { AppSettings } from '../settings/app.settings';
import { CurrenciesSettings } from '../settings/currencies.settings';
import { map } from 'rxjs/operators';


@Injectable()
export class CurrencyService{
    public currencyStr:string = 'EUR';
    public currencyUpdated:EventEmitter<number> = new EventEmitter<number>();
    constructor(private http:HttpCssClient, private nativeHttp:HttpClient){}

    public updateCurrency(currency:Object):Observable<any>{
        let url=AppSettings.UPDATE_CURRENCY;
        return this.http.post(url,currency).pipe(map(response => {
            return response;
        }));
    }

    public setCurrencyStr(currency:number){
        if(this.http.getHeader("CurrencyCookie") != `${currency}`){
            this.currencyStr = AppSettings.currencies[currency];
            this.http.addHeader("CurrencyCookie",`${currency}`);
            this.currencyUpdated.emit(currency);
        }else{
        }
    }

    public getCountryByIp():Observable<any>{
        return this.nativeHttp.get(AppSettings.GEOIP_TOOLS);
    }

    public findCurrencyByGeolocation(countryCode:string){
        let curr = CurrenciesSettings.currenciesMap[countryCode];
        if(curr == null){
            curr = 3;
        }

        return curr;
    }
}